/* eslint-disable no-await-in-loop */

import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { GetExportFlashLogReport, GetFlashLogReports } from './types';
import { FlashLogSummaryResponseBody } from '../entities/flash-log-v1/flash-log-summary-response-body';
import { SortByType, OrderByType } from '../entities/flash-log-v1/query-types';
import { FlashLogExportResponseBody } from '../entities/flash-log-v1';
import { axiosInstance } from "../axios-instance";

class FlashLogReports {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  private storageV1BaseUrl?: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string, storageV1BaseUrl?: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
    this.storageV1BaseUrl = storageV1BaseUrl;
  }

  getFlashLogSummaries(
    input: GetFlashLogReports,
  ): Promise<AxiosResponse<FlashLogSummaryResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    const {
      sortBy = SortByType.flashDate,
      orderBy = OrderByType.DESC,
      limit = 100,
      skip = 0,
      batchId = '',
    } = input;
    const queryParameters = {
      ...input,
      sortBy: sortBy.toString(),
      orderBy,
      limit,
      skip,
      batchId,
    };

    return axiosInstance.get<FlashLogSummaryResponseBody>(`${this.baseUrl}/summaries`, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  exportFlashLogReportStorageApi = (input: string) => {
    const accessToken = localStorage.getItem('accessToken');
    const url = `${this.storageV1BaseUrl}/files/${input}/metadata`;
    return axiosInstance.get(`${url}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.data.status === 'uploaded') {
          window.location = response.data?.downloadUrl;
          return response.data?.downloadUrl;
        }
        return '';
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  exportFlashLog(
    input: GetExportFlashLogReport, setLoading: Function,
  ): Promise<AxiosResponse<FlashLogExportResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    const queryParameters = {
      flashDate: input,
    };
    return axiosInstance.get<FlashLogExportResponseBody>(`${this.baseUrl}/export`, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => this.fetchRetry(response?.data?.fileId, 10, setLoading));
  }

  fetchRetry = async (input: string, n: number, setLoading: Function) => {
    let error;
    try {
      const isUrlGenerated = await this.exportFlashLogReportStorageApi(input);
      if (isUrlGenerated === '' && n - 1 !== 0) {
        await new Promise(() => setTimeout(() => this.fetchRetry(input, n - 1, setLoading), 30000));
      } else {
        clearTimeout();
        setLoading(false);
        return isUrlGenerated;
      }
    } catch (error_) {
      error = error_;
    }
    return error;
  };
}

export default FlashLogReports;
